import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { PharmacyOrdersFilterSettingsModel } from "../Models/PharmacyOrdersFilterSettingsModel";
import { PharmacyOrdersTableSettingsModel } from "../Models/PharmacyOrdersTableSettingsModel";
import { PharmacyOrderHandler } from "./Handlers/PharmacyOrderHandler";

let defaultInstance: PharmacyOrdersStore;

class PharmacyOrdersStore extends BaseStore {
    private pharmacyOrderHandler: PharmacyOrderHandler;
    private mapper: RequestMapper;

    public pharmacyOrdersTableSettings: PharmacyOrdersTableSettingsModel;
    public pharmacyOrdersFilterSettings: PharmacyOrdersFilterSettingsModel;
    public pharmacyOrdersIds: string[];
    public currentPharmacyOrderId: string;
    public totalPharmacyOrders: number;
    public isAllergiesAndReactionsExpanded: boolean;

    constructor() {
        super();

        this.pharmacyOrderHandler = new PharmacyOrderHandler();
        this.mapper = new RequestMapper();
        this.mapper.AddInstance(this.pharmacyOrderHandler);

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => {
            this.mapper.Map(request, this);
        });
    }

    public static createSingleton(): PharmacyOrdersStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new PharmacyOrdersStore());
    }
}

export { PharmacyOrdersStore, defaultInstance as pharmacyOrdersStore };
